import script from "./DropDownButton.vue?vue&type=script&setup=true&lang=js"
export * from "./DropDownButton.vue?vue&type=script&setup=true&lang=js"

import "./DropDownButton.vue?vue&type=style&index=0&id=fa5e03d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa5e03d2"]])

export default __exports__